import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'

const CourseList = ({ courses, handleRedirect, placeholder }) => {
  const columns = [{
    dataField: 'id',
    text: 'ID',
    align: 'left',
    headerAlign: 'left'
  }, {
    dataField: 'name',
    text: 'Name',
    align: 'left',
    headerAlign: 'left'
  }]

  const rowStyle = {
    cursor: "pointer"
  }

  return (
    <BootstrapTable keyField='id' data={courses} columns={columns} rowEvents={handleRedirect} noDataIndication={placeholder || "No courses"} hover bordered={false} rowStyle={rowStyle} />
  )
}

export default CourseList